var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "#5E2FDD",
    stroke: "#5E2FDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80911 14.287H9.80894H8.498C8.37936 14.287 8.27957 14.3512 8.23024 14.4449C8.18027 14.5398 8.18462 14.6625 8.26585 14.7575L8.26591 14.7575L13.4028 20.7562L13.4028 20.7563C13.703 21.1065 14.2721 21.1058 14.5736 20.7567L14.574 20.7562L23.7329 10.0582C23.733 10.058 23.7332 10.0577 23.7334 10.0575C23.8155 9.96292 23.8192 9.84003 23.7693 9.7457C23.7199 9.65243 23.6202 9.58828 23.5017 9.58828H22.1907C21.966 9.58828 21.7487 9.68311 21.6057 9.85199C21.6056 9.85211 21.6055 9.85223 21.6054 9.85235L13.9875 18.7477L10.3937 14.5504L10.2797 14.6479L10.3936 14.5503L10.3937 14.5504C10.3227 14.4673 10.233 14.401 10.1319 14.3557C10.0308 14.3105 9.92052 14.2871 9.80911 14.287Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.fb1a0b6008f7c0078140e4b00ece2b34.svg";
export { ForwardRef as ReactComponent };